import { render, staticRenderFns } from "./BookingCharges.vue?vue&type=template&id=7853ee23&"
import script from "./BookingCharges.vue?vue&type=script&lang=js&"
export * from "./BookingCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports